// extracted by mini-css-extract-plugin
module.exports = {"user":"BirAY5zb","more":"m48itB8d","tab":"Iiipv7y9","num":"xkztczYz","empty":"HdQGmS8I"};